import styled from 'styled-components';
import * as tokens from '../../tokens';

export const TotalWrapper = styled.div`
  width: 100%;
  height: 3000px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
`;
